<div class="card mt-4">
  <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>

<div class="card mt-4">

<div class="flex justify-center mt-4">
  <div class="w-full md:w-1/2">

    <h3 class="font-semibold text-xl mb-4 text-center">Liste des DO's</h3>

    <div *ngIf="selectedDo" class="mt-6 text-center">
      <h2 class="text-xl font-semibold text-gray-800">
        DO sélectionné : {{ selectedDo }}
      </h2>
    </div>

    <div class="filter-card border border-gray-300 rounded-md p-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Sélectionnez un DO
      </label>

      <p-dropdown
        [options]="filteredDoList"
        [(ngModel)]="selectedDo"
        [filter]="true"
        optionLabel="label"
        optionValue="value"
        filterPlaceholder="Rechercher un DO..."
        placeholder="Sélectionner un DO"
        class="w-full text-sm mb-4">

        <ng-template let-option pTemplate="item">
          <div class="flex items-center text-sm">
            <i class="pi pi-table mr-2 text-xs"></i>
            <span>{{ option.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="mt-6">
      <h3 class="font-semibold text-xl mb-2 text-center">Période des données</h3>
      <div class="flex flex-col md:flex-row gap-4">
        <div class="filter-card border border-gray-300 rounded-md p-4 w-full">
          <label class="block text-sm font-medium text-gray-700 mb-1">
            <i class="pi pi-calendar mr-1"></i> Date de début
          </label>
          <p-datepicker [(ngModel)]="startDate"
                        [showIcon]="true"
                        [maxDate]="endDate || maxDate"
                        [minDate]="minDate"
                        dateFormat="dd/mm/yy"
                        [showButtonBar]="true"
                        [readonlyInput]="true"
                        placeholder="Sélectionnez une date"
                        [styleClass]="'w-full'">
          </p-datepicker>

        </div>

        <div class="filter-card border border-gray-300 rounded-md p-4 w-full">
          <label class="block text-sm font-medium text-gray-700 mb-1">
            <i class="pi pi-calendar mr-1"></i> Date de fin
          </label>
        <p-datepicker [(ngModel)]="endDate"
                        [showIcon]="true"
                        [maxDate]="endDate || maxDate"
                        [minDate]="minDate"
                        dateFormat="dd/mm/yy"
                        [showButtonBar]="true"
                        [readonlyInput]="true"
                        placeholder="Sélectionnez une date"
                        [styleClass]="'w-full'">
          </p-datepicker>
        </div>
      </div>

      <div *ngIf="startDate && endDate && !validateDates()" class="text-red-500 text-sm mt-2 text-center">
        <i class="pi pi-exclamation-triangle mr-2"></i>
        La date de fin doit être supérieure ou égale à la date de début et antérieure à aujourd'hui.
      </div>
    </div>

    <div class="mt-6 text-center">
      <button pButton
              type="button"
              label="Exporter"
              icon="pi pi-download"
              (click)="exportClientReport()"
              [disabled]="!selectedDo || !validateDates() || isLoading">
      </button>
    </div>
  </div>
</div>

    <div class="preview-section border border-gray-200 rounded-lg p-4 mt-6" *ngIf="showPreviewTable">
      <h4 class="text-lg font-semibold mb-3 text-gray-700">Prévisualisation</h4>
      <p-table [value]="previewData" [loading]="loadingPreview" [responsive]="true"
               styleClass="p-datatable-striped p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr class="bg-gray-50">
            <th *ngFor="let col of previewColumns"
                class="border-r border-gray-200 p-3 text-left font-medium text-gray-700 last:border-r-0">
              {{ col }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td *ngFor="let col of previewColumns"
                class="border-r border-gray-200 p-3 text-gray-600 last:border-r-0">
              {{ rowData[col] }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
</div>

<p-toast></p-toast>
